import {
  API_ENDPOINT_ADD_RECURRING_TRANSACTION,
  API_ENDPOINT_ALL_RECURRING_TRANSACTIONS,
  API_ENDPOINT_DELETE_RECURRING_TRANSACTION,
  API_ENDPOINT_UPDATE_RECURRING_TRANSACTION,
} from "src/helpers/endpoint-urls";
import apiClient from "../helpers/api-client";
import { ETransactionType } from "src/helpers/constants";

interface INewRecurringTransaction {
  transaction: string;
  payTo: string;
  taxes: number;
  description: string;
  subTotal: number;
  type: ETransactionType;
  discount: number;
  category: string;
  total: number;
  frequency: string;
  nextPayment: string;
  currency: string;
}

export const getAllRecurringTransactions = async () => {
  try {
    return await apiClient.get(API_ENDPOINT_ALL_RECURRING_TRANSACTIONS);
  } catch (_e) {
    throw _e;
  }
};

export const createRecurringTransaction = async ({
  fieldsToSave,
}: {
  fieldsToSave: INewRecurringTransaction;
}) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINT_ADD_RECURRING_TRANSACTION,
      fieldsToSave,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Error al agregar transacción");
    }
  } catch (e) {
    throw e;
  }
};

export const updateRecurringTransaction = async ({
  fieldsToSave,
}: {
  fieldsToSave: INewRecurringTransaction;
}) => {
  try {
    const response = await apiClient.put(
      API_ENDPOINT_UPDATE_RECURRING_TRANSACTION,
      fieldsToSave,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response?.data) {
      return response.data;
    } else {
      throw new Error("Error al actualizar la transacción");
    }
  } catch (e) {
    throw e;
  }
};

export const deleteRecurringTransactions = async ({
  transactionIds,
  sendToRecycle = true,
}: {
  transactionIds: Array<string>;
  sendToRecycle?: boolean;
}) => {
  return await apiClient.delete(
    `${API_ENDPOINT_DELETE_RECURRING_TRANSACTION}`,
    {
      data: {
        transactionIds,
        sendToRecycle,
      },
    },
  );
};
